<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
        <div class="container">

            <div class="form-group" style="margin-top: 30px">
                <router-link to="/project/list" class="btn btn-default">بازگشت</router-link>
            </div>

            <div class="panel panel-default">
                <div class="panel-heading">ویرایش </div>
                <div class="panel-body">
                    <form v-on:submit.prevent="saveForm()">





<!--                        <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label">{{ $t('categories') }}</label>-->
<!--                                <select class="form-control" v-model="item.parent_id" >-->
<!--                                    <option v-for="(product_category,index) in product_categories" :value="product_category.id" :key="index">-->

<!--                                        {{ product_category.title}}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->





                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"> عنوان</label>
                                <input type="text" v-model="item.title" class="form-control">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"> Code</label>
                                <input type="text" v-model="item.code" class="form-control">
                            </div>
                        </div>
                        <!--<div class="row">-->
                        <!--<div class="col-xs-12 form-group">-->
                        <!--<label class="control-label">تصویر</label>-->
                        <!--<input type="text" v-model="item.image" class="form-control">-->
                        <!--</div>-->
                        <!--</div>-->
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">توضیحات</label>
                                <input type="text" v-model="item.description" class="form-control">
                            </div>
                        </div>



                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <button class="btn btn-success">ویرایش</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };


    export default {

        mounted() {
            let app = this;
            let id = app.$route.params.id;
            app.itemId = id;
            axios
                .get('/api/projects/' + id, app.auth)
                .then(function (resp) {
                    app.item = resp.data.data;
                })
                .catch(function () {
                    alert("بارگذاری دسته بندی ها امکان پذیر نیست");
                    //                    console.log('a: ' + auth)
                });



            axios
                .get('/api/projects', this.auth)
                .then(response => {
                    this.product_categories = response.data.data;

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })







        },
        data: function () {
            return {
                auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
                itemId: null,
                item: {
                    parent_id: '',
                    title: '',
                    image: null,
                    description: ''
                },

                errors: [],
                productCategories: []

            }
        },


        methods: {
            saveForm() {
                var app = this;
                var newItem = app.item;
                axios.patch('/api/projects/' + app.itemId, newItem, app.auth)
                    .then(function (resp) {
                        console.log(resp)
                        app.$router.replace('/project/list');
                        app.$snotify.info("با موفقیت ثبت شد")
                    })
                    .catch(function (e) {
                         console.log(e)
                        app.errors.push(e.response.data.messages);
//                        for (let value of e.response.data.messages_fa) {
// //                        for (let error of Object.entries(value[1])) {
// //                            console.log(app.object.entries(app.errors[0]));

//                             app.$snotify.warning(value,
//                                 {
//                                     timeout: 7000,
// //                                    showProgressBar: false,
//                                     closeOnClick: true,
//                                     pauseOnHover: true
//                                 });

// //                        }
//                         }
                    });
            }
        }
    }

</script>
